import { Footer } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import {
  getAppsSection,
  getBottomFooterBar,
  getLinksSection,
  getSocialSection,
} from '../../store/footer/footer.selectors';

export const FooterConnected: React.FunctionComponent = props => {
  const linksSection = useSelector(getLinksSection);
  const socialSection = useSelector(getSocialSection);
  const appsSection = useSelector(getAppsSection);
  const bottomFooterBar = useSelector(getBottomFooterBar);
  return <Footer {...{ linksSection, socialSection, appsSection, bottomFooterBar }} />;
};
